/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AccountSecurityRouteImport } from './routes/account/security'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as WSlugRouteImport } from './routes/w/$slug'
import { Route as WSlugIndexRouteImport } from './routes/w/$slug/index'
import { Route as WSlugAuditRouteImport } from './routes/w/$slug/audit'
import { Route as WSlugInboxRouteImport } from './routes/w/$slug/inbox'
import { Route as WSlugMembersRouteImport } from './routes/w/$slug/members'
import { Route as WSlugSettingsRouteImport } from './routes/w/$slug/settings'
import { Route as WSlugCampaignsIndexRouteImport } from './routes/w/$slug/campaigns/index'
import { Route as WSlugCampaignsCampaignIdRouteImport } from './routes/w/$slug/campaigns/$campaignId'
import { Route as WSlugCampaignsNewRouteImport } from './routes/w/$slug/campaigns/new'
import { Route as WSlugCampaignsCampaignIdTasksTaskIdRouteImport } from './routes/w/$slug/campaigns/$campaignId_.tasks.$taskId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSecurityRoute = AccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugRoute = WSlugRouteImport.update({
  id: '/w/$slug',
  path: '/w/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugIndexRoute = WSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugAuditRoute = WSlugAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugInboxRoute = WSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugMembersRoute = WSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugSettingsRoute = WSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugCampaignsIndexRoute = WSlugCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugCampaignsCampaignIdRoute =
  WSlugCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => WSlugRoute,
  } as any)
const WSlugCampaignsNewRoute = WSlugCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => WSlugRoute,
} as any)
const WSlugCampaignsCampaignIdTasksTaskIdRoute =
  WSlugCampaignsCampaignIdTasksTaskIdRouteImport.update({
    id: '/campaigns/$campaignId_/tasks/$taskId',
    path: '/campaigns/$campaignId/tasks/$taskId',
    getParentRoute: () => WSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/two-factor': typeof TwoFactorRoute
  '/account/security': typeof AccountSecurityRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$slug': typeof WSlugRouteWithChildren
  '/w/$slug/audit': typeof WSlugAuditRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/members': typeof WSlugMembersRoute
  '/w/$slug/settings': typeof WSlugSettingsRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/campaigns/$campaignId': typeof WSlugCampaignsCampaignIdRoute
  '/w/$slug/campaigns/new': typeof WSlugCampaignsNewRoute
  '/w/$slug/campaigns/': typeof WSlugCampaignsIndexRoute
  '/w/$slug/campaigns/$campaignId/tasks/$taskId': typeof WSlugCampaignsCampaignIdTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/two-factor': typeof TwoFactorRoute
  '/account/security': typeof AccountSecurityRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$slug/audit': typeof WSlugAuditRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/members': typeof WSlugMembersRoute
  '/w/$slug/settings': typeof WSlugSettingsRoute
  '/w/$slug': typeof WSlugIndexRoute
  '/w/$slug/campaigns/$campaignId': typeof WSlugCampaignsCampaignIdRoute
  '/w/$slug/campaigns/new': typeof WSlugCampaignsNewRoute
  '/w/$slug/campaigns': typeof WSlugCampaignsIndexRoute
  '/w/$slug/campaigns/$campaignId/tasks/$taskId': typeof WSlugCampaignsCampaignIdTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/two-factor': typeof TwoFactorRoute
  '/account/security': typeof AccountSecurityRoute
  '/invite/$token': typeof InviteTokenRoute
  '/w/$slug': typeof WSlugRouteWithChildren
  '/w/$slug/audit': typeof WSlugAuditRoute
  '/w/$slug/inbox': typeof WSlugInboxRoute
  '/w/$slug/members': typeof WSlugMembersRoute
  '/w/$slug/settings': typeof WSlugSettingsRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/campaigns/$campaignId': typeof WSlugCampaignsCampaignIdRoute
  '/w/$slug/campaigns/new': typeof WSlugCampaignsNewRoute
  '/w/$slug/campaigns/': typeof WSlugCampaignsIndexRoute
  '/w/$slug/campaigns/$campaignId_/tasks/$taskId': typeof WSlugCampaignsCampaignIdTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/two-factor'
    | '/account/security'
    | '/invite/$token'
    | '/w/$slug'
    | '/w/$slug/audit'
    | '/w/$slug/inbox'
    | '/w/$slug/members'
    | '/w/$slug/settings'
    | '/w/$slug/'
    | '/w/$slug/campaigns/$campaignId'
    | '/w/$slug/campaigns/new'
    | '/w/$slug/campaigns/'
    | '/w/$slug/campaigns/$campaignId/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/two-factor'
    | '/account/security'
    | '/invite/$token'
    | '/w/$slug/audit'
    | '/w/$slug/inbox'
    | '/w/$slug/members'
    | '/w/$slug/settings'
    | '/w/$slug'
    | '/w/$slug/campaigns/$campaignId'
    | '/w/$slug/campaigns/new'
    | '/w/$slug/campaigns'
    | '/w/$slug/campaigns/$campaignId/tasks/$taskId'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/two-factor'
    | '/account/security'
    | '/invite/$token'
    | '/w/$slug'
    | '/w/$slug/audit'
    | '/w/$slug/inbox'
    | '/w/$slug/members'
    | '/w/$slug/settings'
    | '/w/$slug/'
    | '/w/$slug/campaigns/$campaignId'
    | '/w/$slug/campaigns/new'
    | '/w/$slug/campaigns/'
    | '/w/$slug/campaigns/$campaignId_/tasks/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  TwoFactorRoute: typeof TwoFactorRoute
  AccountSecurityRoute: typeof AccountSecurityRoute
  InviteTokenRoute: typeof InviteTokenRoute
  WSlugRoute: typeof WSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/security': {
      id: '/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AccountSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug': {
      id: '/w/$slug'
      path: '/w/$slug'
      fullPath: '/w/$slug'
      preLoaderRoute: typeof WSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug/': {
      id: '/w/$slug/'
      path: '/'
      fullPath: '/w/$slug/'
      preLoaderRoute: typeof WSlugIndexRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/audit': {
      id: '/w/$slug/audit'
      path: '/audit'
      fullPath: '/w/$slug/audit'
      preLoaderRoute: typeof WSlugAuditRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/inbox': {
      id: '/w/$slug/inbox'
      path: '/inbox'
      fullPath: '/w/$slug/inbox'
      preLoaderRoute: typeof WSlugInboxRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/members': {
      id: '/w/$slug/members'
      path: '/members'
      fullPath: '/w/$slug/members'
      preLoaderRoute: typeof WSlugMembersRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/settings': {
      id: '/w/$slug/settings'
      path: '/settings'
      fullPath: '/w/$slug/settings'
      preLoaderRoute: typeof WSlugSettingsRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/campaigns/': {
      id: '/w/$slug/campaigns/'
      path: '/campaigns'
      fullPath: '/w/$slug/campaigns/'
      preLoaderRoute: typeof WSlugCampaignsIndexRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/campaigns/$campaignId': {
      id: '/w/$slug/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/w/$slug/campaigns/$campaignId'
      preLoaderRoute: typeof WSlugCampaignsCampaignIdRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/campaigns/new': {
      id: '/w/$slug/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/w/$slug/campaigns/new'
      preLoaderRoute: typeof WSlugCampaignsNewRouteImport
      parentRoute: typeof WSlugRoute
    }
    '/w/$slug/campaigns/$campaignId_/tasks/$taskId': {
      id: '/w/$slug/campaigns/$campaignId_/tasks/$taskId'
      path: '/campaigns/$campaignId/tasks/$taskId'
      fullPath: '/w/$slug/campaigns/$campaignId/tasks/$taskId'
      preLoaderRoute: typeof WSlugCampaignsCampaignIdTasksTaskIdRouteImport
      parentRoute: typeof WSlugRoute
    }
  }
}

interface WSlugRouteChildren {
  WSlugAuditRoute: typeof WSlugAuditRoute
  WSlugInboxRoute: typeof WSlugInboxRoute
  WSlugMembersRoute: typeof WSlugMembersRoute
  WSlugSettingsRoute: typeof WSlugSettingsRoute
  WSlugIndexRoute: typeof WSlugIndexRoute
  WSlugCampaignsCampaignIdRoute: typeof WSlugCampaignsCampaignIdRoute
  WSlugCampaignsNewRoute: typeof WSlugCampaignsNewRoute
  WSlugCampaignsIndexRoute: typeof WSlugCampaignsIndexRoute
  WSlugCampaignsCampaignIdTasksTaskIdRoute: typeof WSlugCampaignsCampaignIdTasksTaskIdRoute
}

const WSlugRouteChildren: WSlugRouteChildren = {
  WSlugAuditRoute: WSlugAuditRoute,
  WSlugInboxRoute: WSlugInboxRoute,
  WSlugMembersRoute: WSlugMembersRoute,
  WSlugSettingsRoute: WSlugSettingsRoute,
  WSlugIndexRoute: WSlugIndexRoute,
  WSlugCampaignsCampaignIdRoute: WSlugCampaignsCampaignIdRoute,
  WSlugCampaignsNewRoute: WSlugCampaignsNewRoute,
  WSlugCampaignsIndexRoute: WSlugCampaignsIndexRoute,
  WSlugCampaignsCampaignIdTasksTaskIdRoute:
    WSlugCampaignsCampaignIdTasksTaskIdRoute,
}

const WSlugRouteWithChildren = WSlugRoute._addFileChildren(WSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  TwoFactorRoute: TwoFactorRoute,
  AccountSecurityRoute: AccountSecurityRoute,
  InviteTokenRoute: InviteTokenRoute,
  WSlugRoute: WSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
